import { BackendClient, type BackendTypes } from '@tf/api';

export const monitoringSearchMatchStatusUpdate = async ({
	graphNodeId,
	data,
}: BackendTypes.MonitoringSearchMatchStatusUpdateData): Promise<void> => {
	const _res = await BackendClient.getInstance().monitoringSearchMatchStatusUpdate({ graphNodeId: graphNodeId }, data);
};
